import { createReducer, on } from '@ngrx/store';
import { loadedChargers } from './chargers.actions';
import { initialState } from './chargers.state';

export const chargersReducer = createReducer(
  initialState,
  on(loadedChargers, (state, { chargers }) => ({ ...state, chargers })),
);
